import React, { useState, useRef } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import axios from 'axios'

import Email from './Email'
import CreditCard from './CreditCard'
import Name from './Name'
import Country from './Country'
import styles from './modal.css';

const Payment = props => {
  const [emailRequired, setEmailRequired] = useState(false)
  const [nameRequired, setNameRequired] = useState(false)
  const [zipRequired, setZipRequired] = useState(false)
  const [ccRequired, setCCRequired] = useState(false)
  const emailRef = useRef('')
  const nameRef = useRef('')
  const zipRef = useRef('')
  const ccRef = useRef({ cc: '', exp: '', cvc: '' })
  const [valid, setValid] = useState({
    email: false,
    cc: false,
    name: false,
    zip: false
  })
  const [state, setState] = useState(0) // 0 = waiting, 1 = submitting
  const [submitLabel, setSubmitLabel] = useState('Pay')
  const [showDecline,setShowDecline] = useState(false)
  const submitData = () => {
    setSubmitLabel('Processing')
    setState(1)
    axios
      .post('https://api.nightexchange.com/web/process', {
        // city: props.package.city,
        // package: props.package.package,
        email: emailRef.current,
        name: nameRef.current,
        zip: zipRef.current,
        creditCard: ccRef.current,
        packageId: props.package
      })
      .then(function (response) {
        console.log('approved', response.data)
        setState(0)
        setSubmitLabel('Pay')
        if (response.data.approved) {
          alert('Approved')
        } else {
          setShowDecline(true)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
      })
  }


  const handleSubmit = event => {
    event.preventDefault()
    //console.log('handleSubmit', valid)
    //console.log('name', nameRef.current, emailRef.current, zipRef.current)
    console.log('package',props.package)

    if (valid.email && valid.cc && valid.name && valid.zip) {
      //console.log('submit data')
      submitData()
      return
    }

    if (emailRef.current === '') setEmailRequired(true)
    if (nameRef.current === '')
    {
      //console.log('name missing')
      setNameRequired(true)
    }
    if (zipRef.current === '') setZipRequired(true)
    if (
      ccRef.current.cc === '' &&
      ccRef.current.exp === '' &&
      ccRef.current.cvc === ''
    ) {
      // console.log('ccRequired')
      setCCRequired(true)
    } else setCCRequired(false)
    // const form = event.currentTarget
  }

  const handleCCBlur = e => {
    ccRef.current = e
    // console.log('handleCCBlur', ccRef.current)
  }

  const validForm = () => {
    return valid.email && valid.cc && valid.name && valid.zip
  }
  const Declined = () => {
    const handleClose =() => setShowDecline(false)
    return (
      <Modal show={showDecline} onHide={handleClose} className = "modal-center">
        <Modal.Header closeButton>
          <Modal.Title>Declined</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your card was declined.  Please try a different card.</Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <Form noValidate onSubmit={handleSubmit} style={{ maxWidth: '400px' }} disabled>
      <Email
        required={emailRequired}
        onBlur={e => (emailRef.current = e)}
        onSetValid={e => {
          setValid({ ...valid, email: e })
        }}
        disabled={state === 1}
      />
      <CreditCard
        required={ccRequired}
        onBlur={handleCCBlur}
        onSetValid={e => {
          setValid({ ...valid, cc: e })
        }}
        disabled={state === 1}
      />
      <Name
        required={nameRequired}
        onBlur={e => (nameRef.current = e)}
        onSetValid={e => {
          setValid({ ...valid, name: e })
        }}
        disabled={state === 1}
      />
      <Country
        required={zipRequired}
        onBlur={e => (zipRef.current = e)}
        onSetValid={e => {
          setValid({ ...valid, zip: e })
        }}
        disabled={state === 1}
      />
      <Button
        className='mb-3'
        type='submit'
        style={{
          width: '100%',
          color: !validForm() && '#C0C0C0'
        }}
        disabled={state === 1}
      >
        {submitLabel}
        {validForm() &&
          (state === 0 ? (
            <i
              style={{
                color: 'white',
                position: 'absolute',
                paddingLeft: 50
              }}
              className='float-end bi-lock-fill'
            ></i>
          ) : (
            <Spinner
              size='sm'
              animation='border'
            />
          ))}
       
      </Button>
      <Declined/>
    </Form>
  )
}

export default Payment